const ANONYMOUS_PRESENTER_HASH = 'ic-ap-hash';

// we use roomRuinfileId to distinguish between different room sessions
export const getRunFileStorageKey = (presId: string, roomRunfileId: string | undefined = ''): string => {
    return `ncc-runfileId-${presId}-${roomRunfileId}`;
};

export const getAnonymousPresenterHash = (): string => localStorage.getItem(ANONYMOUS_PRESENTER_HASH) || '';

export const setAnonymousPresenterHash = (hash: string): void => {
    localStorage.setItem(ANONYMOUS_PRESENTER_HASH, hash);
};

export const removeAnonymousPresenterHash = (): void => {
    localStorage.removeItem(ANONYMOUS_PRESENTER_HASH);
};
